import styled from 'styled-components';
import { ReactComponent as LikeLineIcon } from '../../icons/like.line.svg';
import { ReactComponent as LikeShapeIcon } from '../../icons/like.shape.svg';

const StyledButton = styled.button`
  min-width: 52px;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 100%;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s, fill 0.2s;
`;

const LikeButton = ({ onClick, selected }) => {
  return (
    <StyledButton onClick={onClick} className="bg-secondary-light dark:bg-secondary-dark">
      {selected
        ? <LikeShapeIcon
            width="24px"
            height="24px"
            className="fill-primary-light dark:fill-primary-dark"
          />
        : <LikeLineIcon
            width="24px"
            height="24px"
            className="fill-primary-light dark:fill-primary-dark"
          />}
    </StyledButton>
  );
};

export default LikeButton;
